import BaseForm from '../base';
export class VoiceDownPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
